/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMenu = createReactComponent("menu", "IconMenu", [
  ["path", { d: "M4 8l16 0", key: "svg-0" }],
  ["path", { d: "M4 16l16 0", key: "svg-1" }]
]);

export { IconMenu as default };
//# sourceMappingURL=IconMenu.js.map
